import { useQuery } from 'react-query';

import { getQuoteColumnsKey, useRequest } from '@frontend/api';
import type { QueryFunction, ViewsColumnData } from '@frontend/api';

import { QuoteColumnsKey } from './types';

export const useGetQuoteColumns: QueryFunction<
  ViewsColumnData,
  [],
  QuoteColumnsKey
> = (params = {}) => {
  const { requestOptions } = params;
  const request = useRequest(requestOptions);
  const queryKey = getQuoteColumnsKey();

  return useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/display_configs/quotes`, {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
  });
};
